import MockAdapter from 'axios-mock-adapter/types'

export function mockAnnouncement(mocker: MockAdapter) {
  mocker.onGet('/message/announcement/last').reply((config) => {
    return [
      200,
      {
        code: 200,
        data: {
          // id: 1,
          // title: 'announcement title',
          // content: 'announcement content',
          // publishTime: Date.now(),
          // category: 0,
          // link: '',
          // expirationDate: Date.now(),
        },
      },
    ]
  })
}
